import React from "react";

import Airdrop from "./Airdrop";
import Home from "./Home";
import Images from "./Images";
import Presentations from "./Presentations";
import Roadmap from "./Roadmap";
import Team from "./Teams";
import Community from "./Community";
import TeamSection from "./TeamSection";

function Main(props) {
  return (
    <div className="bg-[#01030d]">
      <Home />
      <div className="mt-[5vh]">
        <Presentations />
        <Images />
        <Airdrop />
        <Roadmap />
        <Team />
        <TeamSection />
        <Community />
      </div>
    </div>
  );
}

export default Main;
